import React, { useEffect, useState } from 'react';
import {
  Routes,
  Route,
  BrowserRouter
} from "react-router-dom";

import { Home } from './features/home/home';
import { Market } from './features/market';
import './i18n';

import { lightTheme, darkTheme } from './vaishno/dist/themes';
import { selectedTheme } from './vaishno/dist/slices';

import { ThemeProvider } from '@mui/material/styles';


import { useSelector } from 'react-redux';


function App() {

  const themeName = useSelector(selectedTheme);

  return (
    <ThemeProvider theme={themeName === 'light' ? lightTheme : darkTheme}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Market />} />
          <Route path="/:market/:variety" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
